const PENDING_KEY = 'trialWelcomePending';
const SHOWN_PREFIX = 'trialWelcomeShown:';

export function markTrialWelcomePending(): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(PENDING_KEY, '1');
}

export function isTrialWelcomePending(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return sessionStorage.getItem(PENDING_KEY) === '1';
}

export function clearTrialWelcomePending(): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.removeItem(PENDING_KEY);
}

export function hasSeenTrialWelcome(userId: string): boolean {
  if (typeof window === 'undefined') {
    return true;
  }
  return localStorage.getItem(`${SHOWN_PREFIX}${userId}`) === '1';
}

export function markTrialWelcomeShown(userId: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(`${SHOWN_PREFIX}${userId}`, '1');
  clearTrialWelcomePending();
}
